const survey = {
    title: {
        vi: `Phân tích độ linh hoạt doanh nghiệp`,
        en: `Analyze your business agility`,
    },
    paragraph1: {
        vi: `
            Các doanh nghiệp vừa và nhỏ nhanh nhẹn cạnh tranh hơn, chớp lấy cơ hội 
            nhanh hơn và có thể xây dựng mối quan hệ bền chặt hơn với các nhà cung cấp, 
            nhà phân phối và khách hàng.
        `,
        en: `
            Agile small and midsize businesses are more competitive, 
            jump on opportunities more quickly and are able to build 
            stronger relationships with suppliers, distributors and customers.
        `,        
    },
    paragraph2: {
        vi: `
            Nhưng làm thế nào để bạn trở nên nhanh nhẹn hơn với tư cách là một doanh nghiệp? 
            Thứ nhất, bạn cần biết ngày hôm nay bạn nhanh nhẹn như thế nào. Sau đó, 
            những gì cần phải được thực hiện để trở nên nhanh nhẹn hơn vào ngày mai.
        `,
        en: `
            But how do you become more agile as a business? Firstly, 
            you need to know how agile you are today. Then what needs to 
            be done to become more agile tomorrow.
        `,        
    },
    start_button: {
        vi: `Bắt đầu bài phân tích`,
        en: `Start your analysis now`,        
    },
    overview: {
        vi: `Tổng quát`,
        en: `Overview`,        
    },
    overview_paragraph1: {
        vi: `
            Công cụ Phân tích đánh giá sự nhanh nhạy trong doanh nghiệp của bạn trên 5 lĩnh vực chính:
            Lập kế hoạch chiến lược, Quy trình, Khách Hàng Thân Thiết, 
            Nhà cung cấp và Nhà phân phối, Trải Nghiệm Người Dùng
        `,
        en: `
            The Analysis Tool assesses your businesses agility across 5 key areas: 
            Strategic Planning, Processes, Customer Relationships, Suppliers and Distributors, 
            People Experience
        `,        
    },
    overview_paragraph2: {
        vi: `
            Sau khi hoàn thành, bạn sẽ có một cái nhìn tổng quan đầy đủ về sự nhanh nhạy 
            trong tổ chức của bạn với các khuyến nghị có thể hành động. 
            Những điều này sẽ cho phép bạn thúc đẩy những thay đổi quan trọng đối với
            doanh nghiệp của bạn, đảm bảo làn sóng thành công tiếp theo cho tổ chức của bạn.
        `,
        en: `
            Once completed, you will get a full overview of your organizational agility with 
            actionable recommendations. These will enable you to drive important changes to 
            your business, ensuring the next wave of success for your organization.
        `,        
    },
    overview_paragraph3: {
        vi: `Quá trình này sẽ mất khoảng 5-7 phút để hoàn thành.`,
        en: `This will take around 5-7 minutes to complete.`,        
    },
    thanks: {
        vi: `<p className="text-center">Cám ơn đã thực hiện bài phân tích<br/>Chúng tôi sẽ liên hệ ngay với bạn !</p>`,
        en: `<p className="text-center">Thank you for survey<br/>We’ll contact you soon !</p>`,
    },
    back_button: {
        vi: `Trở về trang chủ`,
        en: `Back to home`
    },
    question: {
        vi: `Câu hỏi`,
        en: `Question`,
    },
    select_categories: {
        vi: `Chọn danh mục khảo sát`,
        en: `Choose survey category`,
    },
    enter_input: {
        vi: `Nhập câu trả lời`,
        en: `Enter your answer`,
    }
}

export default survey